<p-multiselect
  [inputId]="inputId()"
  [ariaLabel]="ariaLabel() || undefined"
  [ariaLabelledBy]="ariaLabelledBy()"
  [options]="options()"
  [optionLabel]="optionLabel()"
  [optionValue]="optionValue()"
  [placeholder]="placeholder()"
  [showClear]="showClear()"
  [filter]="filter()"
  [filterBy]="filterBy()"
  [resetFilterOnHide]="resetFilterOnHide()"
  [appendTo]="appendTo()"
  [styleClass]="styleClass()"
  [disabled]="isDisabled()"
  [maxSelectedLabels]="maxSelectedLabels()"
  [display]="display()"
  [dropdownIcon]="dropdownIcon()"
  [selectedItemsLabel]="selectedItemsLabel()"
  [displaySelectedLabel]="displaySelectedLabel()"
  [virtualScroll]="virtualScroll()"
  [virtualScrollItemSize]="virtualScrollItemSize()"
  [group]="group()"
  [fluid]="fluid()"
  [ngModel]="innerValue"
  [ngModelOptions]="{ standalone: true }"
  (onChange)="onSelectionChange($event)"
  (onClear)="onClear()"
  (onSelectAllChange)="onSelectAllChange($event)"
  [attr.data-testid]="dataTestId()"
>
  @if (selectedItemsTemplate()) {
    <ng-template let-value pTemplate="selectedItems">
      <ng-container
        *ngTemplateOutlet="
          selectedItemsTemplate()!;
          context: { $implicit: value }
        "
      />
    </ng-template>
  }
</p-multiselect>
